export const SELECT_ALL_PASSENGERS_FOR_DELETION =
  'SELECT_ALL_PASSENGERS_FOR_DELETION'

export default (passengerIds: string[]) => ({
  type: SELECT_ALL_PASSENGERS_FOR_DELETION,
  passengerIds,
})
